import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  anyOf: {
    id: 'studio.xJNj62',
    defaultMessage: 'Any of the following:',
  },
  oneOf: {
    id: 'studio.VJC3aY',
    defaultMessage: 'Exactly one of the following:',
  },
  option: {
    id: 'studio.6fpLnn',
    defaultMessage: 'Option',
  },
});
